import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info with Logo */}
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/88ba7c39681cb796cee4e89aebadeff7/76dc25c0bcc578ed59ccf9df16a388c2.png" 
                alt="FARWAYS Viagens & Turismo" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              {t('footerDescription')}
            </p>
            
            {/* Company Legal Info */}
            <div className="bg-orange-50/10 border border-orange-500/20 rounded-xl p-4 mb-6">
              <p className="text-sm text-gray-200 leading-relaxed">
                <strong className="text-orange-400">FARWAYS</strong> - Marca registada de <strong>Alves e Frade, Lda.</strong><br />
                <strong>NIPC:</strong> 505413850<br />
                <strong>RNAVT:</strong> 8586
              </p>
            </div>

            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                <i className="ri-twitter-x-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-300">
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-orange-400">{t('quickLinks')}</h4>
            <nav>
              <ul className="space-y-3">
                <li>
                  <a href="#servicos" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span>{t('services')}</span>
                  </a>
                </li>
                <li>
                  <a href="#frota" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span>{t('fleet')}</span>
                  </a>
                </li>
                <li>
                  <Link to="/pricing" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span>{t('pricing')}</span>
                  </Link>
                </li>
                <li>
                  <Link 
                    to={i18n.language === 'es' ? '/preguntas-frecuentes' : i18n.language === 'en' ? '/faq' : '/perguntas-frequentes'}
                    className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span>{t('faq')}</span>
                  </Link>
                </li>
                <li>
                  <a href="#sobre" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span>{t('about')}</span>
                  </a>
                </li>
                <li>
                  <Link to="/contactos" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span>{t('contacts')}</span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Popular Routes - SEO Content */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-orange-400">Rotas Populares</h4>
            <nav>
              <ul className="space-y-3 text-sm">
                <li>
                  <a href="#reservas" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span><strong>Faro</strong> → Albufeira</span>
                  </a>
                </li>
                <li>
                  <a href="#reservas" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span><strong>Faro</strong> → Lagos</span>
                  </a>
                </li>
                <li>
                  <a href="#reservas" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span><strong>Faro</strong> → Portimão</span>
                  </a>
                </li>
                <li>
                  <a href="#reservas" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span><strong>Faro</strong> → Vilamoura</span>
                  </a>
                </li>
                <li>
                  <a href="#reservas" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span><strong>Faro</strong> → Tavira</span>
                  </a>
                </li>
                <li>
                  <a href="#reservas" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center space-x-2 group cursor-pointer">
                    <i className="ri-arrow-right-s-line text-orange-500 group-hover:translate-x-1 transition-transform"></i>
                    <span><strong>Faro</strong> → Lisboa</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-orange-400">{t('contact')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Telefone</p>
                  <a href="tel:+351937545000" className="text-white hover:text-orange-400 transition-colors font-semibold">
                    +351 937 545 000
                  </a>
                  <p className="text-xs text-gray-500 mt-1">(Custo de uma chamada para a rede móvel nacional)</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Email</p>
                  <a href="mailto:reservas@faroways.com" className="text-white hover:text-orange-400 transition-colors">
                    reservas@faroways.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Localização</p>
                  <p className="text-white">
                    <strong>Faro, Algarve</strong><br />
                    Portugal
                  </p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Horário</p>
                  <p className="text-white font-semibold">
                    <strong>24/7</strong> Disponível
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links Section */}
        <div className="border-t border-gray-800 pt-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-4xl mx-auto">
            {/* Livro de Reclamações */}
            <a 
              href="https://www.livroreclamacoes.pt" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group bg-gray-800/30 hover:bg-gray-800/50 rounded-lg p-4 transition-all duration-300 flex items-center space-x-3"
            >
              <div className="w-10 h-10 bg-gray-700/50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-file-list-3-line text-gray-400 text-lg"></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-gray-300 font-medium text-sm mb-0.5">
                  {t('complaintBook')}
                </p>
                <p className="text-gray-500 text-xs truncate">
                  www.livroreclamacoes.pt
                </p>
              </div>
              <i className="ri-arrow-right-up-line text-gray-500 group-hover:text-gray-400 transition-colors text-sm"></i>
            </a>

            {/* Centro de Arbitragem */}
            <a 
              href="https://www.consumoalgarve.pt" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group bg-gray-800/30 hover:bg-gray-800/50 rounded-lg p-4 transition-all duration-300 flex items-center space-x-3"
            >
              <div className="w-10 h-10 bg-gray-700/50 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-scales-3-line text-gray-400 text-lg"></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-gray-300 font-medium text-sm mb-0.5">
                  {t('arbitrationCenter')}
                </p>
                <p className="text-gray-500 text-xs truncate">
                  consumoalgarve.pt
                </p>
              </div>
              <i className="ri-arrow-right-up-line text-gray-500 group-hover:text-gray-400 transition-colors text-sm"></i>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © {new Date().getFullYear()} FARWAYS. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap justify-center md:justify-end items-center gap-6 text-sm">
            <a href="/privacy-policy" className="text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap">
              {t('privacyPolicy')}
            </a>
            <a href="/terms-of-service" className="text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap">
              {t('termsOfService')}
            </a>
            <a href="/cookie-policy" className="text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap">
              {t('cookiePolicy')}
            </a>
            <a 
              href="https://serverws.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap"
            >
              ServerWS
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
